import React from 'react'
import RenderedHtmlContent from "../rendered_html_content";
import {useSelector} from "react-redux";

export const HtmlContentImageMap = ({imageMap}) => {
  const htmlContents = useSelector(state => state.htmlContents)
  const htmlContentIdentifier = htmlContents.find(html => html.id === imageMap.html_content_id)?.identifier

  return <RenderedHtmlContent identifier={htmlContentIdentifier}/>
}
